var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarB = function SvgDefaultAvatarB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6 55.3c7 0 11.3-3.7 11.3-8.7 0-4.3-3.1-6.8-6.1-7.4 2.1-1 4.4-3 4.4-6.6 0-3.8-2.9-7.5-10.1-7.5-1.8 0-5 .2-6.6.2h-2.7c-2.9 0-4.8.3-4.8 1.5 0 .9 1 1.2 3.1 1.3.5.2.7 1.9.7 4.5v15.2c0 2.9-.1 4.3-.7 4.5-2.2.1-3.1.4-3.1 1.4 0 1.2 2 1.5 4.9 1.5h2.5c1.3-.1 4.4.1 7.2.1zm-5.9-7.6v-6.5c1.6-.2 3.3-.2 4.6-.2 4.8 0 7.4 2.2 7.4 5.9 0 3.5-2.2 5.5-7.5 5.5-1.8 0-3.2-.1-4.1-.5-.4-.1-.4-1.9-.4-4.2zm0-9.4v-5.8c0-2.3 0-3.8.4-4.2.9-.3 2.4-.5 3.6-.5 5.4 0 6.6 2.9 6.6 5.4 0 3.4-2.2 5.2-5.5 5.2-1.9.1-3.5 0-5.1-.1z"
  })));
};
export default SvgDefaultAvatarB;